import { ADD_TOUCHED_ORDER, REMOVE_TOUCHED_ORDER } from '../giveaway-landing.actions';
export const touchedOrderInitialState = [];
export const touchedOrderReducer = (state = touchedOrderInitialState, action) => {
  switch (action.type) {
    case ADD_TOUCHED_ORDER:
      {
        return [...state.filter(id => id !== action.payload), action.payload];
      }
    case REMOVE_TOUCHED_ORDER:
      {
        return state.filter(id => id !== action.payload);
      }
    default:
      {
        return state;
      }
  }
};